import React from "react";
// import { FichasData } from "../../data/fichas.data";

import icon_soundoff from "../../assets/svgs/MG/icon-sound-off.svg";
import icon_soundon from "../../assets/svgs/MG/icon-sound-on.svg";

import IsPortrait from '../helpers/WindowOrientation';

interface Props {
  car: any;
  audioMute: boolean;
  setAudioMute: (value: boolean) => void;
}

const Topbar: React.FC<Props> = ({ car, audioMute, setAudioMute}) => {

  const isPortrait = IsPortrait();
  //const [ficha, setFicha] = React.useState<any>(null);

  // React.useEffect(() => {
  //   if(!car)
  //     return;
  //   const fichasData: any = FichasData();
  //   setFicha(fichasData[car.id]);
  // }, [car]);
  // 
  // const openURL = (url: string) => {
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  return (
    <div className={`studio-topbar-container ${isPortrait ? 'portrait':''}`}>
      <div className={`studio-topbar-btn2 ${isPortrait ? 'portrait':''} ${audioMute ? '':'selected'}`} onClick={() => {setAudioMute(!audioMute)}}>
        <img className={`studio-topbar-icon ${isPortrait ? 'portrait':''}`} src={!audioMute ? icon_soundon : icon_soundoff} draggable={false} alt=''/>
      </div>
    </div>
  );
};

export default Topbar;